var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"text-tile-400",attrs:{"to":'/leadDetail/' + _vm.model}},[_c('span',[_vm._v("#"+_vm._s(_vm.model))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }